import {ReactNode, useEffect} from 'react'
import {Outlet} from 'react-router'

//import {KTIcon} from '_metronic/helpers'
import {Content} from '_metronic/layout/components/content'
import {ScrollTop} from '_metronic/layout/components/scroll-top'
import {PageDataProvider, useLayout} from '_metronic/layout/core'

type WizardLayoutProps = {
  children?: ReactNode
}

const WizardLayout = ({children}: WizardLayoutProps) => {
  const {setLayout} = useLayout()

  useEffect(() => {
    // Force sidebar to be hidden in this layout
    setLayout({
      app: {
        sidebar: {
          display: false,
        },
      },
    })

    // Reset layout on unmount to restore sidebar for other routes
    return () => {
      setLayout({
        app: {
          sidebar: {
            display: true,
          },
        },
      })
    }
  }, [setLayout])

  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid wizard-layout-page' id='kt_app_page'>
          <div className='app-wrapper flex-column flex-row-fluid flex-grow-1' id='kt_app_wrapper'>
            <div className='app-main flex-column flex-row-fluid h-100' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid h-100'>
                <Content>{children ?? <Outlet />}</Content>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScrollTop />
    </PageDataProvider>
  )
}

export default WizardLayout
